export default "__VITE_ASSET__f1e52dde__"